import Image from "next/image";
import { cn } from "@/lib/utils";
import { carrierLogoSrc } from "@/lib/carrier";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export function ContactPhoneCarrier({
  carrier,
  className,
  ...props
}: { carrier: string | null | undefined } & React.ComponentProps<"span">) {
  const src = carrierLogoSrc(carrier);
  if (!src || !carrier) return null;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          className={cn(
            "-m-2 inline-flex shrink-0 items-center p-2 sm:m-0 sm:p-0",
            className,
          )}
          {...props}
        >
          <Image src={src} alt={carrier} width={14} height={14} quality={100} />
        </span>
      </TooltipTrigger>
      <TooltipContent>{carrier}</TooltipContent>
    </Tooltip>
  );
}
